
export interface AdminInvite{
	email: string
	firstName: string
	lastName: string
	location: string
}

export interface UserInvite{
	email: string
	firstName: string
	lastName: string
	location: string
	role: Role
}

export enum InvitationType {
	Admin = 'Admin',
	User = 'User'
}

export interface Props{
	onClose: () => void
}

export enum Role {
	ApplicantMentee = "ApplicantMentee",
	Mentee = "Mentee",
	Mentor = "Mentor",
}